var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CanvasJSChart',{staticClass:"mt-4",attrs:{"options":_vm.options,"can_print":_vm.dataPoints.length>0,"report_title":_vm.report_title,"report_details":_vm.report_details}})}
var staticRenderFns = []

export { render, staticRenderFns }